<template>
  <div class="marked-item__delete">
    <svg
      @click="remove(item.id)"
      width="20px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 492 492"
      style="enable-background:new 0 0 492 492;"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            fill="#d61313"
            d="M484.128,104.478l-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856c-7.208,0-13.964,2.788-19.028,7.856
                            L203.508,314.81L62.024,173.322c-5.064-5.06-11.82-7.852-19.028-7.852c-7.204,0-13.956,2.792-19.024,7.852l-16.12,16.112
                            C2.784,194.51,0,201.27,0,208.47c0,7.204,2.784,13.96,7.852,19.028l159.744,159.736c0.212,0.3,0.436,0.58,0.696,0.836
                            l16.12,15.852c5.064,5.048,11.82,7.572,19.084,7.572h0.084c7.212,0,13.968-2.524,19.024-7.572l16.124-15.992
                            c0.26-0.256,0.48-0.468,0.612-0.684l244.784-244.76C494.624,132.01,494.624,114.966,484.128,104.478z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>

    <svg
      @click="safe(item.id)"
      width="20px"
      class="dismiss"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512.001 512.001"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            fill="#000"
            d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                        L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,27.586,0,38.109l209.998,209.998L7.893,465.999
                        c-10.524,10.524-10.524,27.586,0,38.109c10.524,10.524,27.586,10.523,38.109,0L256,294.11l209.997,209.998
                        c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,10.523-27.586,0-38.109L294.111,256.001z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'delete-request',
    props: {
        item: {
            required: true,
        },
        type: {
            required: true,
        },
    },
    methods: {
        ...mapActions({
            requestForDelete: 'deleteControl/requestForDelete',
        }),
        remove(id) {
            this.$emit('remove', id)
        },
        async safe(id) {
            await this.requestForDelete({
                type: this.type,
                id,
            })
            this.$emit('save')
        },
    },
}
</script>

<style lang="scss" scoped>
.marked-item {
  &__delete {
    margin-left: 5%;
    width: 100px;
    height: 100%;
    display: flex;

    svg {
      cursor: pointer;
      display: inline-block;
      margin-right: 15px !important;
      transition: 0.1s ease-in;

      &:hover {
        transform: scale(1.1);
      }
    }

    .delete path {
      fill: #0f750f;
    }

    // .dismiss path {
    //     fill: #0;
    // }
  }
}
</style>
